import React from 'react';

/**
 * Card and wallet marks drawn inline so the checkout row always renders crisp,
 * with no external requests and no broken images.
 */
const tile = 'flex h-7 w-[48px] items-center justify-center rounded-[3px] bg-white';

/** Every method enabled in Shopify checkout, shown together in one tight block. */
export function PaymentLogos() {
  return <ul className="flex flex-wrap items-center gap-1.5" aria-label="Accepted payment methods" data-id="element-1050" data-mp="2h080d91w0lj">
      <li className={tile} title="Visa" data-id="element-1051" data-mp="3awtctuu0rnmr">
        <svg viewBox="0 0 48 16" className="h-3 w-[38px]" role="img" aria-label="Visa" data-id="element-1052" data-mp="35w5nddlfveun">
          <text x="0" y="13" fill="#1A1F71" fontFamily="Arial, Helvetica, sans-serif" fontSize="15" fontStyle="italic" fontWeight="700" letterSpacing="0.5" data-id="element-1053" data-mp="3ksmzi71gcxi9">
            VISA
          </text>
        </svg>
      </li>

      <li className={tile} title="Mastercard" data-id="element-1054" data-mp="v4dwdmyonnu1">
        <svg viewBox="0 0 40 24" className="h-5 w-[34px]" role="img" aria-label="Mastercard" data-id="element-1055" data-mp="v5ozdkkb0rk3">
          <circle cx="15" cy="12" r="9" fill="#EB001B" data-id="element-1056" data-mp="3v5rasb7wzxpb" />
          <circle cx="25" cy="12" r="9" fill="#F79E1B" data-id="element-1057" data-mp="3wkewzmcsodr" />
          <path d="M20 4.6a9 9 0 000 14.8A9 9 0 0020 4.6z" fill="#FF5F00" data-id="element-1058" data-mp="3z6pl84jjk07" />
        </svg>
      </li>

      <li className={tile} title="American Express" data-id="element-1059" data-mp="8ulwth81mhnn">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="American Express" data-id="element-1060" data-mp="cwqseli1xocx">
          <rect width="52" height="16" rx="2" fill="#2E77BC" data-id="element-1061" data-mp="3cegk9v63pmxy" />
          <text x="26" y="11.5" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" letterSpacing="0.4" data-id="element-1062" data-mp="3hc091p0fdi45">
            AMEX
          </text>
        </svg>
      </li>

      <li className={tile} title="Discover" data-id="element-1063" data-mp="2tlmiy41ehtc7">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Discover" data-id="element-1064" data-mp="2tkuvxhlvd3xj">
          <text x="0" y="12" fill="#231F20" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontWeight="700" data-id="element-1065" data-mp="2xm6ckxmrmetl">
            DISC
          </text>
          <circle cx="44" cy="8" r="6" fill="#F26E21" data-id="element-1066" data-mp="ek3sgygn9qoc" />
        </svg>
      </li>

      <li className={tile} title="Diners Club" data-id="element-1067" data-mp="9kisqltnheak">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Diners Club" data-id="element-1068" data-mp="9ltxooyu0s39">
          <circle cx="8" cy="8" r="7" fill="#0079BE" data-id="element-1069" data-mp="3i1dozify00fo" />
          <circle cx="8" cy="8" r="4.2" fill="#FFFFFF" data-id="element-1070" data-mp="3d17rvmqwllq7" />
          <rect x="7.3" y="3.8" width="1.4" height="8.4" fill="#0079BE" data-id="element-1071" data-mp="3d2skh6tnqulf" />
          <text x="18" y="11.5" fill="#0079BE" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1072" data-mp="3r18zrm5l5tf6">
            Diners
          </text>
        </svg>
      </li>

      <li className={tile} title="JCB" data-id="element-1073" data-mp="16ai4ep53ksxd">
        <svg viewBox="0 0 42 16" className="h-4 w-[38px]" role="img" aria-label="JCB" data-id="element-1074" data-mp="1696x4fcg131i">
          <rect x="1" y="1" width="12" height="14" rx="3" fill="#0E4C96" data-id="element-1075" data-mp="128enhkznsw4p" />
          <rect x="15" y="1" width="12" height="14" rx="3" fill="#E21836" data-id="element-1076" data-mp="19s61oz8w8hda" />
          <rect x="29" y="1" width="12" height="14" rx="3" fill="#007B40" data-id="element-1077" data-mp="1ersej7kt7vlk" />
          <text x="7" y="11.5" textAnchor="middle" fill="#FFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1078" data-mp="1eppfjy1ois4p">J</text>
          <text x="21" y="11.5" textAnchor="middle" fill="#FFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1079" data-mp="14t2xfh0qmf6d">C</text>
          <text x="35" y="11.5" textAnchor="middle" fill="#FFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" data-id="element-1080" data-mp="1sjp1kx7mffb3">B</text>
        </svg>
      </li>

      <li className={tile} title="UnionPay" data-id="element-1081" data-mp="1iu5hjo869fen">
        <svg viewBox="0 0 44 16" className="h-4 w-[40px]" role="img" aria-label="UnionPay" data-id="element-1082" data-mp="1iraz228py4nv">
          <path d="M3 1h10l-3 14H0z" fill="#E21836" data-id="element-1083" data-mp="1nqnj6f87gxmr" />
          <path d="M14 1h10l-3 14H11z" fill="#00447C" data-id="element-1084" data-mp="2bhszevi25rxl" />
          <path d="M25 1h10l-3 14H22z" fill="#007B84" data-id="element-1085" data-mp="2bg85n83kid0s" />
          <text x="18" y="11" textAnchor="middle" fill="#FFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="5.5" fontWeight="700" data-id="element-1086" data-mp="2g9t4f2czjb11">
            UnionPay
          </text>
        </svg>
      </li>

      <li className={tile} title="PayPal" data-id="element-1087" data-mp="nkbt4grp0p22">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="PayPal" data-id="element-1088" data-mp="nnptxkkpkq7e">
          <text x="0" y="12" fill="#253B80" fontFamily="Arial, Helvetica, sans-serif" fontSize="11" fontWeight="700" data-id="element-1089" data-mp="iocwk5w7o0qk">
            Pay
          </text>
          <text x="23" y="12" fill="#179BD7" fontFamily="Arial, Helvetica, sans-serif" fontSize="11" fontWeight="700" data-id="element-1090" data-mp="1bb7eow5k2o0v">
            Pal
          </text>
        </svg>
      </li>

      <li className={tile} title="Venmo" data-id="element-1091" data-mp="11kux9ct1fayy">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Venmo" data-id="element-1092" data-mp="11jtgqst95w9u">
          <rect width="52" height="16" rx="3" fill="#008CFF" data-id="element-1093" data-mp="wl022x28bz83" />
          <text x="26" y="11.5" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontStyle="italic" fontWeight="700" data-id="element-1094" data-mp="1u15ll8xmab2x">
            venmo
          </text>
        </svg>
      </li>

      <li className={tile} title="Amazon Pay" data-id="element-1095" data-mp="1xk4q5su2hpep">
        <svg viewBox="0 0 52 20" className="h-5 w-[46px]" role="img" aria-label="Amazon Pay" data-id="element-1096" data-mp="1xlft5qfout4r">
          <text x="1" y="10" fill="#232F3E" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontWeight="700" data-id="element-1097" data-mp="21l84gawgvddt">
            amazon
          </text>
          <path d="M3 13.2c5 2.6 12.5 2.8 18.5.2" stroke="#FF9900" strokeWidth="1.4" fill="none" strokeLinecap="round" data-id="element-1098" data-mp="2bje5yred2hi5" />
          <path d="M19.6 12.2l2.2 1-1 2.1" stroke="#FF9900" strokeWidth="1.2" fill="none" strokeLinecap="round" data-id="element-1099" data-mp="2ghfmp5obe4qg" />
          <text x="34" y="10" fill="#232F3E" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontWeight="400" data-id="element-1100" data-mp="2ki98nti759gp">
            pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Apple Pay" data-id="element-1101" data-mp="2u8kh9tcts6tx">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Apple Pay" data-id="element-1102" data-mp="2ubgetgkrgthu">
          <path d="M9.6 4.3c-.5.6-1.3 1-2 .9-.1-.8.3-1.6.7-2.1.5-.6 1.3-1 2-1 .1.8-.2 1.6-.7 2.2zm.7 1.1c-1.1-.1-2 .6-2.5.6-.5 0-1.3-.6-2.2-.6-1.1 0-2.2.7-2.7 1.7-1.2 2-.3 5 .9 6.6.6.8 1.2 1.7 2.1 1.6.9 0 1.2-.6 2.3-.6 1.1 0 1.3.6 2.2.6.9 0 1.5-.8 2.1-1.7.4-.6.6-1 .9-1.7-2.3-.9-2.6-4-.3-5.3-.4-.6-1-1.1-1.8-1.2z" fill="#000000" data-id="element-1103" data-mp="2z6m0qfe5y85x" />
          <text x="17" y="13" fill="#000000" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="600" data-id="element-1104" data-mp="2oa8zrrnzw1st">
            Pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Google Pay" data-id="element-1105" data-mp="2x9ciguj92f6s">
        <svg viewBox="0 0 56 16" className="h-4 w-[46px]" role="img" aria-label="Google Pay" data-id="element-1106" data-mp="2x8axnycfmebv">
          <text x="0" y="12" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="700" data-id="element-1107" data-mp="2sasw4t0qv1dw">
            <tspan fill="#4285F4" data-id="element-1108" data-mp="3768tp80j9ff1">G</tspan>
            <tspan fill="#EA4335" data-id="element-1109" data-mp="328p5pge19o9w">o</tspan>
            <tspan fill="#FBBC05" data-id="element-1110" data-mp="329rwzpf9psqc">o</tspan>
            <tspan fill="#4285F4" data-id="element-1111" data-mp="1cu0rd9lvtw98">g</tspan>
            <tspan fill="#34A853" data-id="element-1112" data-mp="1cv3inin4a0po">l</tspan>
            <tspan fill="#EA4335" data-id="element-1113" data-mp="17v7d3eyru180">e</tspan>
          </text>
          <text x="38" y="12" fill="#5F6368" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="600" data-id="element-1114" data-mp="17ws815ozzm6e">
            Pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Shop Pay" data-id="element-1115" data-mp="3ohxa53issia7">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Shop Pay" data-id="element-1116" data-mp="3ojqg0gll6yh5">
          <rect width="52" height="16" rx="3" fill="#5A31F4" data-id="element-1117" data-mp="39shnnzqauz0b" />
          <text x="26" y="11.5" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" letterSpacing="0.3" data-id="element-1118" data-mp="3eqsv63t4gxfd">
            shop Pay
          </text>
        </svg>
      </li>
    </ul>;
}